import React from "react"
import { useTranslation } from "react-i18next"

import { NumberInput } from "shared/ui/input/number/NumberInput"

import { useProductPositionFormCoreContext } from "../../contexts/ProductPositionFormCoreContext"
import { useProductPositionFormLoadingContext } from "../../contexts/ProductPositionFormLoadingContext"

const renderReadonlyValue = (value: string | number | null) => value || "-"

export const ProductPositionQuantityInput = React.memo(() => {
  const { t } = useTranslation()
  const { isReadonly, isDisabled, formOptions } =
    useProductPositionFormCoreContext()
  const { isLoading } = useProductPositionFormLoadingContext()
  const { hideQuantity, isQuantityReadonly } = formOptions || {}

  if (hideQuantity) return null

  return (
    <div className="product-position-form__quantity">
      <NumberInput.Root
        name="productPosition.quantity"
        label={t("General.Quantity")}
        data-testid="product-position-form__quantity"
        step={1}
        min={1}
        format={{ maximumFractionDigits: 0, minimumFractionDigits: 0 }}
        loading={isLoading}
        disabled={isDisabled}
        readonly={isReadonly || isQuantityReadonly}
      >
        <NumberInput.Label />
        <NumberInput.Group>
          <NumberInput.Decrement />
          <NumberInput.Focus>
            <NumberInput.Input data-testid="product-position-form__quantity__input" />
          </NumberInput.Focus>
          <NumberInput.Increment />
        </NumberInput.Group>
        <NumberInput.Readonly render={renderReadonlyValue} />
        <NumberInput.ErrorMessage />
      </NumberInput.Root>
    </div>
  )
})
